import React from "react";
import { Link } from "react-router-dom";

type FooterLink = {
  to: string;
  label: string;
};

type FooterLinkSectionProps = {
  title: string;
  links: FooterLink[];
};

const FooterLinkSection: React.FC<FooterLinkSectionProps> = ({ title, links }) => {
  return (
    <div>
      <h3 className="text-gray-900 font-semibold mb-4">{title}</h3>
      <ul className="space-y-3 text-gray-600">
        {links.map((link) => (
          <li key={link.to}>
            <Link to={link.to} className="hover:text-primary">
              {link.label}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default FooterLinkSection;
